import { useNavigate } from "react-router-dom"
import { useAuth } from "../../../hooks/useAuth"
import { useEffect, useState } from "react"
import useHomepage from "./useHomepage"
import { Carousel } from "react-bootstrap"
import ActionButtonGradient from "../../../components/button/ActionButtonGradient"

const Homepage = () => {
    const {getCurrentRole} = useAuth()
    const role = getCurrentRole()
    const navigate = useNavigate()
    const {
        payload,
        getActiveHomepage,
    } = useHomepage()
    const [activeIndex, setActiveIndex] = useState(0)
    const [progress, setProgress] = useState(0)
    const [isPaused, setIsPaused] = useState(false)

    useEffect(() => {
        getActiveHomepage()
    }, [])

    useEffect(() => {
        if (!payload || payload.length <= 1 || isPaused) return;

        setProgress(0);
        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 100) {
                    setActiveIndex((current) => (current + 1) % payload.length);
                    return 0;
                }
                return prev + 2;
            });
        }, 100);

        return () => clearInterval(interval);
    }, [activeIndex, payload, isPaused]);
    
    return(
        <div className="container-fluid justify-content-center">
            <div className="d-flex align-items-center justify-content-between mb-4">
                <h3 style={{ margin: 0, fontWeight: 600, color: '#1a1a1a' }}>Homepage</h3>
                {
                    role && (role.includes("superadmin") || role.includes("admin"))? 
                    <ActionButtonGradient
                        onClick={() => navigate("list")}
                        variant="primary"
                        children={"Edit Announcement"}
                    />
                    : <></>
                }
            </div>

            <div style={{width: "100%", position: 'relative'}}>
                <div 
                    className="carousel-container" 
                    onMouseEnter={() => setIsPaused(true)}
                    onMouseLeave={() => setIsPaused(false)}
                    style={{ display: 'flex', alignItems: 'center', gap: '20px' }}
                >
                    <Carousel 
                        activeIndex={activeIndex}
                        onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
                        interval={null}
                        controls={true}
                        indicators={false}
                        touch={true}
                        wrap={true}
                        slide={true}
                        style={{
                            borderRadius: '12px',
                            overflow: 'hidden',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                            flex: 1
                        }}
                    >
                    {
                        payload && payload.map((item, index) => (
                            <Carousel.Item key={index}>
                                <img 
                                    src={item.FileLink} 
                                    alt={item.FileName} 
                                    style={{ 
                                        width: '100%', 
                                        height: '75vh',
                                        objectFit: 'contain',
                                        backgroundColor: '#ffffff'
                                    }} 
                                    loading="lazy"
                                />
                            </Carousel.Item>
                        ))
                    }
                </Carousel>
                </div>

                <style>{`
                    .carousel-container .carousel-control-prev,
                    .carousel-container .carousel-control-next {
                        opacity: 0;
                        transition: opacity 0.25s ease;
                        width: 35px;
                        height: 35px;
                        top: 50%;
                        transform: translateY(-50%);
                        z-index: 10;
                    }

                    .carousel-container .carousel-control-prev {
                        left: 15px;
                    }

                    .carousel-container .carousel-control-next {
                        right: 15px;
                    }

                    .carousel-container:hover .carousel-control-prev,
                    .carousel-container:hover .carousel-control-next {
                        opacity: 0.9;
                    }

                    .carousel-container .carousel-control-prev-icon,
                    .carousel-container .carousel-control-next-icon {
                        background-color: rgba(2, 180, 204, 0.95);
                        border-radius: 50%;
                        padding: 10px;
                        width: 35px;
                        height: 35px;
                        box-shadow: 0 2px 8px rgba(2, 180, 204, 0.3);
                    }

                    .carousel-container .carousel-control-prev:hover .carousel-control-prev-icon,
                    .carousel-container .carousel-control-next:hover .carousel-control-next-icon {
                        background-color: rgba(2, 180, 204, 1);
                        transform: scale(1.05);
                        box-shadow: 0 4px 12px rgba(2, 180, 204, 0.4);
                    }
                `}</style>

                {/* Progress Bar Navigation */}
                {payload && payload.length > 1 && (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '6px',
                        marginTop: '16px',
                        alignItems: 'center'
                    }}>
                        {payload.map((_, index) => (
                            <div
                                key={index}
                                onClick={() => setActiveIndex(index)}
                                style={{
                                    flex: 1,
                                    maxWidth: '60px',
                                    height: '3px',
                                    backgroundColor: '#dee2e6',
                                    borderRadius: '1.5px',
                                    cursor: 'pointer',
                                    overflow: 'hidden',
                                    position: 'relative'
                                }}
                            >
                                <div
                                    style={{
                                        height: '100%',
                                        backgroundColor: '#02B4CC',
                                        width: activeIndex === index ? `${progress}%` : activeIndex > index ? '100%' : '0%',
                                        transition: activeIndex === index ? 'width 0.1s linear' : 'width 0.3s ease',
                                        borderRadius: '1.5px'
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* <div className="d-flex justify-content-center align-items-center">
                Logged In
                <button onClick={() =>logout()} className="btn btn-danger">
                    Log out
                </button>
            </div> */}
            {/* <Loading/> */}
        </div>
    )
}

export default Homepage